const config = {
	NODE_ENV: process.env.NODE_ENV ?? 'development',
	APP_NAME: process.env.REACT_APP_NAME ?? 'ishema',
	API_URL: process.env.REACT_APP_SERVER_URL,
	PAYMENT_API_URL:
		process.env.REACT_APP_PAYMENT_API_URL ??
		'https://api.tickets.ishema.rw/api/v1/payments'
};

export default config;
